export const getTodayLocalISO = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const isFutureISO = (val) => {
  if (!val) return false;
  try {
    const today = getTodayLocalISO();
    return String(val) > today;
  } catch {
    return false;
  }
};

export const clampToTodayISO = (val) => {
  return isFutureISO(val) ? getTodayLocalISO() : val;
};

